var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title))]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.sumPoint",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("numFormat")(item.sumPoint,"0,000,000"))+" ")]}},{key:"item.sumAmount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("numFormat")(item.sumAmount,"0,000,000"))+" ")]}}])})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }